import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Avatar, Spin } from 'antd';
//import { downloadImage } from '../../../redux/fileSlice';
import './style.css';

const ImageComponent = ({ imageId, size }) => {
	const dispatch = useDispatch();
	const [imageUrl, setImageUrl] = useState(null);
	const [makingApiCall, setMakingApiCall] = useState(false);
	const fetchImage = async () => {
		setMakingApiCall(true);
		/* await dispatch(downloadImage(imageId))
			.unwrap()
			.then((data) => {
				setImageUrl(URL.createObjectURL(data));
			})
			.catch((error) => {
				console.log(error);
			})
			.finally(() => {
				setMakingApiCall(false);
			}); */
	};
	useEffect(() => {
		fetchImage();
	}, [dispatch, imageId]);

	return (
		<Spin spinning={makingApiCall}>
			{imageUrl && (
				<Avatar
					src={imageUrl}
					style={{ marginRight: '0.5em' }}
					size={size || { xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
					gap={4}
					shape='square'
					className='custom-avatar'
				/>
			)}
		</Spin>
	);
};

export default ImageComponent;
